import { QBInitActionParams } from './actions';

const QB: QBInitActionParams = {
  appId: '80472',
  authKey: 'qVAGu7ndaCga5Sx',
  authSecret: 'NZqrmTNgaxM7VSW',
  accountKey: 'uK_8uinNyz8-npTNB6tx',
  config: {
    debug: true,
  },
};

type JanusConfig = Pick<QBConferencingClientParams, 'debug' | 'iceServers'>;

const Janus: JanusConfig = {
  debug: true,
  iceServers: [
    {
      urls: 'turn:turn.quickblox.com:3478',
      username: 'quickblox',
      credential: 'baccb97ba2d92d71e26eb9886da5f1e0',
    },
  ],
};

export default { QB, Janus };
